module.exports = __webpack_public_path__ + "1fa3c86f8466d366c99919cd2fba6870.png";